/**
 * True when this page is running inside the Riders desktop shell (Electron).
 *
 * `import.meta.env.VITE_ENV === "electron"` does NOT answer this. That flag
 * marks the separate electron-mode bundle, and the shell does not load it: it
 * points a BrowserWindow at the live editor, so the code running there is the
 * ordinary production (or staging) build with VITE_ENV set accordingly.
 *
 * The only thing that tells the two apart at runtime is the preload script's
 * contextBridge surface, which exists solely in the shell. See
 * `desktop/README.md` -- "Renderer-side code that only matters on the desktop
 * belongs in src/, feature-detected on window.electron".
 */
export const isElectronShell = (): boolean =>
  typeof window !== "undefined" && !!window.electron;
